/**
 * Composant de route admin nécessitant une authentification avec rôle ADMIN.
 */
import React from 'react';
import { Navigate } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';

const AdminRoute = ({ children }) => {
  const { isAuthenticated, isAdmin, loading } = useAuth();

  if (loading) {
    return (
      <div className="flex items-center justify-center min-h-screen">
        <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-primary-600"></div>
      </div>
    );
  }

  // Si non authentifié, rediriger vers login
  if (!isAuthenticated) {
    return <Navigate to="/login" replace />;
  }

  // Si authentifié mais pas admin, rediriger vers tableau de bord
  if (!isAdmin) {
    return <Navigate to="/tableau-de-bord" replace />;
  }

  return children;
};

export default AdminRoute;
